import React, { useEffect, useState } from 'react';
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from 'react-router-dom';

import "bootstrap/dist/css/bootstrap.min.css";
import './Navigation.css';
import logoOfOurProject1 from '../Images/logoOfOurProject1.jpg'
import TypingHighlight from './TypingHighlight';
import bootcamp1 from '../Images/bootcamp-1.jpg'
import bootcamp2 from '../Images/bootcamp-2.jpg'
import bootcamp3 from '../Images/bootcamp-3.jpg'
import bootcamp4 from '../Images/bootcamp-4.jpg'
import masteringAndBuilding from '../Images/masteringandbuilding.jpg'
import productmanagementai from '../Images/ProductManagementAI.jpg'

const Navigation = () => {
    // State to store the search query and filtered courses
    const [searchQuery, setSearchQuery] = useState('');
    const [courses, setCourses] = useState([
        { id: 1, title: 'MLOps Pro Specialization', path: '/mlops' },
        { id: 2, title: 'Mastering Data Analysis with Python', path: '/DataAnalysisWithPython' },
        { id: 3, title: 'Mastering GenAI Specialisation', path: '/masteringGenAI' },
        { id: 4, title: 'Data Science Masterclass', path: '/datasciencemasterclass' },
        { id: 5, title: 'Advanced LLM Ops Specialization', path: '/advancedllm' }
        // Add more courses here or fetch from an API
    ]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    // Scroll animations on load and scroll
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll('.fade-in, .slide-in');
            elements.forEach(element => {
                const position = element.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;

                if (position < windowHeight) {
                    element.classList.add('show');
                }
            });
        };

        handleScroll(); // Trigger animation on load
        window.addEventListener('scroll', () => {
            const elements = document.querySelectorAll('.fade-in, .slide-in');
            elements.forEach(el => {
                const position = el.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;

                if (position < windowHeight - 100) {
                    el.classList.add('show');
                } else {
                    el.classList.remove('show'); // Ensures animation triggers again when scrolling back
                }
            });
        });

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Handle the search input
    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        // Filter the courses based on the search query
        if (query) {
            const filtered = courses.filter((course) =>
                course.title.toLowerCase().includes(query)
            );
            setFilteredCourses(filtered);
        } else {
            setFilteredCourses([]);
        }
    };

    return (
        <div className='container'>
            <nav className="navbar navbar-expand-lg bg-body-tertiary fade-in">
                <div className="container-fluid">
                    <a href='/'><img src={logoOfOurProject1} alt='logo' /></a>
                    {/* <a className="navbar-brand fw-bold" href="/">KOTI AI</a> */}

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-5">
                                <li className="nav-item me-3">
                                    <Link className="nav-link active fw-medium" aria-current="page" to="/">Home</Link>
                                </li>
                                <li className="nav-item me-3">
                                    <a className="nav-link fw-medium" href="#">Courses</a>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><a className="dropdown-item" href="/datasciencemasterclass">Data Science</a></li>
                                        <li><a className="dropdown-item" href="/dataAnalysisWithPython">Data Analysis</a></li>
                                        <li><a className="dropdown-item" href="/masteringandbuildingproduct">Mastering AI Product- Langchain & LangGraph</a></li>
                                        <li><a className="dropdown-item" href="/productmanagementinai">Product Management In AI</a></li>
                                        <li><a className="dropdown-item" href="/masteringGenAI">Mastering Gen AI</a></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><a className="dropdown-item" href="/allcourses">More Courses</a></li>
                                    </ul>
                                </li>
                                <li className="nav-item me-3">
                                    <a className="nav-link fw-medium" href="#">Service</a>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><a className="dropdown-item" href="#">Product Development</a></li>
                                        <li><a className="dropdown-item" href="/trainingandworkshop">Training & Workshops</a></li>
                                        <li><a className="dropdown-item" href="#">Customer Success</a></li>
                                    </ul>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link fw-medium" href="#">About</a>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><a className="dropdown-item" href="/ourteam">Our Team</a></li>
                                        <li><a className="dropdown-item" href="#about-section">Mission & Vision</a></li>
                                        <li><a className="dropdown-item" href="#">Reviews</a></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><a className="dropdown-item" href="#contact-section">Contact Us</a></li>
                                    </ul>
                                </li>
                            </ul>
                            </div>
                            <div className="search-bar-container" style={{ position: 'relative', width: '50%' }}>
                                <form className="d-flex" role="search" onSubmit={(e) => e.preventDefault()}>
                                    <input
                                        className="form-control me-2"
                                        type="search"
                                        value={searchQuery}
                                        onChange={handleSearch}
                                        placeholder="Search for courses..."
                                        aria-label="Search"
                                        autoComplete="on"
                                    />
                                    <button className="btn btn-outline-success" type="submit">Search</button>

                                    {/* Dropdown search results */}
                                    {searchQuery && filteredCourses.length > 0 && (
                                        <div className="dropdown-search-results">
                                            <ul>
                                                {filteredCourses.map((course) => (
                                                    <li key={course.id}>
                                                        <Link to={course.path} onClick={() => setSearchQuery('')}>
                                                            {course.title}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </form>
                            </div>
                  
                    <div className='ham-menu'>
                        <button>
                            <GiHamburgerMenu />
                        </button>
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <div className='container banner-ai position-relative z-n1'>
                <img className='animated-image' src="https://static.wixstatic.com/media/f18369_5372ced23a264653b51b1fb9556134f5~mv2.jpg/v1/fill/w_1024,h_357,al_c,q_85,enc_auto/Generative%20AI%20master.jpg" alt="Generative AI master.jpg" width="1284" height="448" />
            </div>


            <p className='text-center w-100 fade-in'>
                Welcome to <span className="highlight-gradient_2">KOTI AI</span>, your gateway to upskilling in
                <TypingHighlight />.
            </p>


            <div className='container justify-content-center p-5 slide-in'>
                <h2 className='font-size-2 '>
                    Discover <span className="highlight-gradient_2">AI</span>
                </h2>
                <p className='fade-in'>
                    Our courses are taught by industry experts with decades of experience from reputed organizations and Tier 1 institutes. You can trust that you'll be learning from the best in the field. It helps to learn AI tools and applications.
                </p>
            </div>

            {/* Courses Section */}
            <div className='p-5 fade-in'>
                <h5>Our Trending Courses</h5>
                <span className='font-size'>Learning everything in AI space</span>
            </div>
            <div className='card-group p-5 slide-in'>
                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src="https://static.wixstatic.com/media/f18369_f8074f5749fc45259e9eee80d3f9a824~mv2.jpg/v1/fit/w_800,h_600,al_c,q_90/file.webp" loading="eager" />
                    <div className="card-body">
                        <h3 className="card-title">Mastering GenAI Specialisation</h3>
                        <p className="card-text">Advanced AI skills.</p>
                        <a href="/masteringGenAI" className="btn btn-primary">View Details</a>
                    </div>
                </div>

                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src={masteringAndBuilding} loading="eager" />
                    <div className="card-body ">
                        <h3 className="card-title">Mastering and Building Product With Langchain and Langraph</h3>
                        <p className="card-text">Learn live from experts.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/masteringandbuildingproduct" className="btn btn-primary">View Details</a>
                    </div>
                </div>

                <div className="card border-3 course-card">
                    <img className='w-100 h-50' alt="" data-hook="image-wrapper" src={productmanagementai} loading="eager" />
                    <div className="card-body ">
                        <h3 className="card-title">Product Management In AI</h3>
                        <p className="card-text">Learn live from experts.</p>
                        <p className="card-text fw-bolder">Coming Soon</p>
                        <a href="/productmanagementinai" className="btn btn-primary">View Details</a>
                    </div>
                </div>
            </div>

            {/* Bootcamp Section */}
            <div className='p-5 fade-in'>
                <h5>Our Online Bootcamp</h5>
                <span className='font-size'>An immersive learning experience</span>
            </div>

            {/* Bootcamp Info */}
            <div class="card-group p-3 slide-in">
                <div class="card me-3">
                    <img src={bootcamp1} alt='bootcampbanner1' />
                    <div class="card-body">
                        <h5 class="card-title">Develop skills for real career growth</h5>
                        <p class="card-text">Cutting-edge curriculum designed in guidance with industry and academia to develop job-ready skills</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>

                <div class="card me-3">
                    <img src={bootcamp2} alt='bootcampbanner-2' />
                    <div class="card-body">
                        <h5 class="card-title">Learn from experts active in their field</h5>
                        <p class="card-text">Leading practitioners bring best practices and case studies to sessions that fit into your work schedule.</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>


                <div class="card me-3">
                    <img src={bootcamp3} alt='bootcampbanner-3' />
                    <div class="card-body">
                        <h5 class="card-title">Learn by working on real-world problems</h5>
                        <p class="card-text">Capstone projects involving real-world datasets with virtual labs for hands-on learning.</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>

                <div class="card">
                    <img src={bootcamp4} alt='bootcampbanner-4' />
                    <div class="card-body">
                        <h5 class="card-title">Structured guidance ensuring learning never stops</h5>
                        <p class="card-text">24x7 Learning support from mentors and a community of like-minded peers.</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>
            </div>

            {/* About Section with Scroll Animations */}
            <div className='about-container p-5 fade-in' id='about-section'>
                <h2 className='p-3'>Mission & Vision</h2>
                <div className='about-para1 m-lg-4 d-flex'>
                    <img src='https://media.istockphoto.com/id/1328167226/vector/open-book.jpg?s=612x612&w=0&k=20&c=yqfKR7Es5IDuM20rtyg4xZihaGTl2waDtvucK1YCTIw=' alt='' />
                    <section>
                        <h4 className='text-primary'>Flexible Learning with Self-Paced Online Courses</h4>
                        <p>Embrace personalized learning with self-paced online courses to study at your convenience and pace.</p>
                    </section>
                </div>
                <div className='about-para1 m-lg-4 d-flex'>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvy4xN8W2ZN2FkIAuq8EYxJy30xpkcXoGADg&s' alt='' />
                    <section>
                        <h4 className='text-primary'>Earn Recognized Credentials with Certificate Courses</h4>
                        <p>Gain valuable credentials recognized in the industry, showcasing your expertise and skills.</p>
                    </section>
                </div>
                <div className='about-para1 m-lg-4 d-flex'>
                    <img src='https://static.vecteezy.com/system/resources/thumbnails/020/212/705/small/email-or-envelope-with-at-sign-icon-in-line-style-design-isolated-on-white-background-editable-stroke-vector.jpg' alt='' />
                    <section>
                        <h4 className='text-primary'>Unmatched 24/7 Mentor Support</h4>
                        <p>Get continuous guidance and support from mentors available 24/7 to enhance your learning journey.</p>
                    </section>
                </div>
                <div className='about-para1 m-lg-4 d-flex'>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRU-A4odFdEfwxwFTvxRT5c6HklcTOvgXdrGw&s' alt='' />
                    <section>
                        <h4 className='text-primary'>Tailored Learning</h4>
                        <p>Get customized e-books that align with your individual learning style and goals for effective education.</p>
                    </section>
                </div>
                <div className='about-para1 m-lg-4 d-flex'>
                    <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTvkp-lTClM88xJzmropi81cHJpNDGQfYULQ&s' alt='' />
                    <section>
                        <h4 className='text-primary'>Real-World Case Studies and Practice Code</h4>
                        <p>Bridge theory and practice with real-world case studies and hands-on coding exercises.</p>
                    </section>
                </div>
            </div>

            {/* Footer Section */}
            <footer>
                <div className='footer p-4 bg-dark'>
                    <div className='d-flex justify-content-between' id='contact-section'>
                        <div className='footer-social text-white'>
                            <h4>Follow us!</h4>
                            <br />
                            <div className='footer-social-links-1'>
                                <a href="https://www.facebook.com/imtusharchaudhary" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Facebook-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                                <a href="https://www.Twitter.com/Tusharcofficial" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Twitter-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                                <a href="https://www.instagram.com/iamtusharchaudhry" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Instagram-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                            </div>
                        </div>
                        <div className='AboutCompany text-white'>
                            <h4>Company</h4>
                            <p className='text-white-50'>Careers</p>
                            <p className='text-white-50'>Newsroom</p>
                            <p className='text-white-50'>Alumni Speak</p>
                            <p className='text-white-50'>Grievance redreesal</p>
                        </div>
                        <div className='WorkWithUs text-white'>
                            <h4>Work With Us</h4>
                            <p className='text-white-50'>Become an instructor</p>
                            <p className='text-white-50'>Blog as guest</p>
                        </div>
                        <div className='ForBusinesses text-white'>
                            <h4>Contact Us</h4>
                            <p className='text-white-50'><i class="bi bi-phone"></i>&nbsp; Request a callback</p>
                            <p className='text-white-50'><i class="bi bi-telephone-plus-fill"></i>&nbsp; +91 8448-313599</p>
                            <p className='text-white-50'><i class="bi bi-envelope-fill"></i>&nbsp; info@kotiai.com</p>
                        </div>
                    </div>
                </div>
                <div className='footer-bottom'>
                    <p>© 2024 kotiai.com | Terms of Service | Privacy Policy</p>
                </div>
            </footer>
        </div>
    )
}

export default Navigation;
